import { useTLang } from 'intl/intl';

import type { SaturationStateProp } from 'features/high-demand/shared/models';

export function useSaturationStateText(props: Props) {
  const { variant, isSingleStore = true } = props;

  const isVariantInPlural = variant === 'deactivated' && !isSingleStore;

  const text = useTLang({ id: `highDemand.state.${variant}` });

  const allDayText = useTLang({ id: 'highDemand.ttlOption.title.day' });

  return {
    allDayText,
    status: isVariantInPlural
      ? text
          .split(' ')
          .map(v => v + 's')
          .join(' ')
      : text,
  };
}

interface Props extends SaturationStateProp {
  isSingleStore?: boolean;
}
